import { Grid, Skeleton } from "@mui/material";
import classNames from "classnames";
import { useEffect, useState } from "react";
import AnalyticsPlanGrid from "shared/components/projectHeadComponents/subscription/analyticsPlanGrid";
import GraphPlansGrid from "shared/components/projectHeadComponents/subscription/graphPlansGrid";
import PlansPurchasedGrid from "shared/components/projectHeadComponents/subscription/plansGrid";
import StatsCard from "shared/components/statsCard";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss";


function Subscription() {
  const [activeTab, setActiveTab] = useState<number>(1);
  const [loader, setLoader] = useState<boolean>(true);

  const toggleLoader = () => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  };

  let statsCard = [
    {
      label: "Free Accounts",
      count: 4933,
      stats: {
        index: true,
        difference: "10%",
      },
    },
    {
      label: "Active Subscriptions",
      count: 1920,
      stats: {
        index: false,
        difference: "2%",
      },
    },
    {
      label: "Lost Subscriptions",
      count: 800,
      stats: {
        index: true,
        difference: "5%",
      },
    },
  ];

  useBreadcrumbs({
    title: "Subscription",
    path: routeConstant?.subscription?.path,
  });

  let headingStats = [
    {
      heading: "Parents",
      stats: 4933,
      id: 1,
      keyword: "individuals",
    },
    {
      heading: "Individual Kids",
      stats: 2470,
      id: 2,
      keyword: "parents",
    },
    {
      heading: "Schools",
      stats: 640,
      id: 3,
      keyword: "schools",
    },
  ];

  useEffect(() => {
    toggleLoader();
  }, []);

  return (
    <div className={styles.mainContainer}>
      <StatsCard statsList={statsCard} label={"Income Stats"} />

      <div className={styles.accountsDetailContainer}>
        <Grid className={styles.actionContainer} container>
          {headingStats?.map((item: any, index: any, arr: any) => {
            return (
              <Grid
                xs={4}
                className={classNames(
                  styles.singleHeadingGrid,
                  activeTab === item?.id && styles.active,
                  index === 0 && styles.borderRadiusLeft,
                  index + 1 === arr.length && styles.borderRadiusRight
                )}
                onClick={() => {
                  setActiveTab(item?.id);
                  toggleLoader();
                }}
              >
                <div className={styles.title}>Subscriptions Analytics for</div>
                <div
                  className={classNames(
                    activeTab === item?.id && styles.activeTab,
                    styles.headingTab
                  )}
                >
                  {item?.heading}
                </div>
              </Grid>
            );
          })}
        </Grid>

        <div className={styles.componentsContainer}>
          {loader ? (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12} xl={3}>
                  <Skeleton
                    variant="rounded"
                    height={250}
                    sx={{ width: "100%" }}
                  />
                  <Skeleton
                    variant="rounded"
                    height={250}
                    sx={{ width: "100%", marginTop: "10px" }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={9}>
                  <Skeleton
                    variant="rounded"
                    sx={{ width: "100%" }}
                    height={510}
                  />
                </Grid>
              </Grid>
              <Skeleton variant="rounded" sx={{ width: "100%" }} height={610} />
            </>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12} xl={3}>
                  <AnalyticsPlanGrid />
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={9}>
                  <GraphPlansGrid activeTab={activeTab} />
                </Grid>
              </Grid>
              <PlansPurchasedGrid activeRole={activeTab} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Subscription;
